import {
  deleteDealView,
  fetchDealViews,
  insertDealView,
  updateDealView,
} from '../../services/dealViews';
import { promptAsk } from '../../store/feedback';

export default function dealViewsHandlers(deps, api) {
  const {
    dealsFilter,
    dealsView,
    session,
    setDealsFilter,
    setDealsView,
    setDealViews,
    setDealViewsOpen,
  } = deps;

  async function loadDealViews() {
    const { data } = await fetchDealViews();
    setDealViews(data || []);
  }

  async function saveCurrentView() {
    const nom = await promptAsk('Nom de la vue', {
      title: 'Enregistrer la vue',
      confirmLabel: 'Enregistrer',
    });
    if (!nom) return;
    await insertDealView(dealsFilter, dealsView, nom, session);
    setDealViewsOpen(false);
    loadDealViews();
  }

  function applyView(v) {
    const c = v.config || {};
    if (c.view) setDealsView(c.view);
    if (c.filter) setDealsFilter({ q: '', statut: [], type: [], resp: [], ...c.filter });
    setDealViewsOpen(false);
  }

  async function deleteView(id) {
    await deleteDealView(id);
    loadDealViews();
  }

  async function toggleShareView(v) {
    await updateDealView(v);
    loadDealViews();
  }

  return { loadDealViews, saveCurrentView, applyView, deleteView, toggleShareView };
}
